<template>
  <div class="page-payment">
    <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2">Payment Methods</h1>
  </div>
</template>

<script>
export default {
  name: 'PaymentMethods',
};
</script>
